import {AlertIcon} from '@primer/octicons-react'
import {AnchoredOverlay, IconButton, Stack, Text} from '@primer/react'
import {useState} from 'react'

export function HiddenUnicodeAlert() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <AnchoredOverlay
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      side="outside-top"
      align="center"
      width="small"
      overlayProps={{role: 'dialog', 'aria-label': 'Hidden Unicode details'}}
      renderAnchor={props => (
        <IconButton
          {...props}
          aria-haspopup={undefined}
          aria-labelledby={undefined}
          /* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- Unicode is a proper noun */
          aria-label="Hidden Unicode"
          className="mr-2"
          icon={AlertIcon}
          size="small"
          variant="invisible"
        />
      )}
    >
      <Stack padding="normal">
        <Text>This line has hidden Unicode characters</Text>
      </Stack>
    </AnchoredOverlay>
  )
}
